// extracted by mini-css-extract-plugin
export var border = "_81-0";
export var borderSelected = "_81-1";
export var check = "_81-6";
export var circle = "_81-2";
export var circleInner = "_81-4";
export var circleInnerDisabled = "_81-8";
export var description = "_81-3";
export var horizontal = "_81-b";
export var input = "_81-5";
export var label = "_81-9";
export var radioButton = "_81-d";
export var radioButtonNoCenter = "_81-e";
export var radioGroup = "_81-a";
export var rightRadio = "_81-f";
export var subcontent = "_81-g";
export var uncheck = "_81-7";
export var vertical = "_81-c";